class ProductAddonsSection {
  constructor(container) {
    this.container = container;
    this.sectionEl = container.closest('.shopify-section') || container;
    this.moveToMount();

    if (!container.querySelector('product-addon')) {
      this.sectionEl.remove();
      return;
    }

    container.classList.add('is-loaded');
  }

  moveToMount() {
    const mount = document.getElementById('product-addons-mount');
    if (!mount || !this.sectionEl) return;
    mount.appendChild(this.sectionEl);
  }
}

document.querySelectorAll('[id^="ProductAddons-"]').forEach((el) => {
  new ProductAddonsSection(el);
});

class ProductAddon extends HTMLElement {
  connectedCallback() {
    this.variants = this.parseVariants();
    this.selectedOptions = this.getInitialOptions();
    this.quantity = 1;
    this.imageEl = this.querySelector('[data-addon-image]');
    this.priceEl = this.querySelector('[data-addon-price]');
    this.idInput = this.querySelector('[data-addon-id]');
    this.qtyInput = this.querySelector('[data-addon-qty]');
    this.addButton = this.querySelector('[data-addon-add]');
    this.qtyDropdown = this.querySelector('[data-addon-qty-dropdown]');

    this.querySelectorAll('[data-addon-toggle]').forEach((toggle) => {
      toggle.addEventListener('click', (event) => {
        event.preventDefault();
        this.toggleDropdown(toggle.closest('[data-addon-dropdown], [data-addon-qty-dropdown]'));
      });
    });

    this.querySelectorAll('[data-addon-option]').forEach((optionBtn) => {
      optionBtn.addEventListener('click', (event) => {
        event.preventDefault();
        if (optionBtn.disabled) return;
        const dropdown = optionBtn.closest('[data-addon-dropdown]');
        const optionIndex = Number(dropdown.dataset.optionIndex);
        this.selectedOptions[optionIndex] = optionBtn.dataset.value;
        this.updateDropdownLabel(dropdown, optionBtn.dataset.value);
        this.closeAllDropdowns();
        this.syncVariant();
      });
    });

    this.querySelectorAll('[data-addon-qty-option]').forEach((optionBtn) => {
      optionBtn.addEventListener('click', (event) => {
        event.preventDefault();
        if (optionBtn.disabled) return;
        this.setQuantity(Number(optionBtn.dataset.value));
        this.closeAllDropdowns();
      });
    });

    this.addButton?.addEventListener('click', this.handleAdd.bind(this));

    document.addEventListener('click', (event) => {
      if (!this.contains(event.target)) this.closeAllDropdowns();
    });

    this.syncVariant();
  }

  parseVariants() {
    const node = this.querySelector('[data-addon-variants]');
    if (!node) return [];
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      console.error('Invalid product addon variants JSON', error);
      return [];
    }
  }

  getInitialOptions() {
    const current = this.variants.find((variant) => String(variant.id) === this.querySelector('[data-addon-id]')?.value);
    if (current?.options) return [...current.options];
    const labels = [...this.querySelectorAll('[data-addon-dropdown]')].map((dropdown) => {
      return dropdown.querySelector('[data-addon-label]')?.textContent?.trim() || '';
    });
    return labels;
  }

  toggleDropdown(dropdown) {
    if (!dropdown) return;
    const isOpen = dropdown.classList.contains('is-open');
    this.closeAllDropdowns();
    if (!isOpen) {
      dropdown.classList.add('is-open');
      dropdown.querySelector('[data-addon-toggle]')?.setAttribute('aria-expanded', 'true');
      dropdown.querySelector('.product-addon__dropdown-menu')?.removeAttribute('hidden');
    }
  }

  closeAllDropdowns() {
    this.querySelectorAll('[data-addon-dropdown], [data-addon-qty-dropdown]').forEach((dropdown) => {
      dropdown.classList.remove('is-open');
      dropdown.querySelector('[data-addon-toggle]')?.setAttribute('aria-expanded', 'false');
      dropdown.querySelector('.product-addon__dropdown-menu')?.setAttribute('hidden', '');
    });
  }

  updateDropdownLabel(dropdown, value) {
    const label = dropdown.querySelector('[data-addon-label]');
    const swatch = dropdown.querySelector('[data-addon-swatch]');
    if (label) label.textContent = value;
    if (swatch) {
      swatch.className = `product-addon__swatch color-${this.handleize(value)}`;
    }
    dropdown.querySelectorAll('[data-addon-option]').forEach((optionBtn) => {
      optionBtn.classList.toggle('is-selected', optionBtn.dataset.value === value);
    });
  }

  setQuantity(qty) {
    this.quantity = Math.max(1, Number(qty) || 1);
    if (this.qtyInput) this.qtyInput.value = String(this.quantity);
    const label = this.qtyDropdown?.querySelector('[data-addon-qty-label]');
    if (label) label.textContent = String(this.quantity);
    this.qtyDropdown?.querySelectorAll('[data-addon-qty-option]').forEach((optionBtn) => {
      optionBtn.classList.toggle('is-selected', Number(optionBtn.dataset.value) === this.quantity);
    });
  }

  syncQuantityOptions(variant) {
    if (!this.qtyDropdown) return;

    let maxQty = 10;
    if (variant?.inventory_management && typeof variant.inventory_quantity === 'number' && variant.inventory_quantity > 0) {
      maxQty = Math.min(10, variant.inventory_quantity);
    }

    this.qtyDropdown.querySelectorAll('[data-addon-qty-option]').forEach((optionBtn) => {
      const value = Number(optionBtn.dataset.value);
      const available = value <= maxQty;
      optionBtn.disabled = !available;
      optionBtn.classList.toggle('is-unavailable', !available);
      optionBtn.hidden = !available;
    });

    if (this.quantity > maxQty) this.setQuantity(maxQty);
  }

  handleize(value) {
    return String(value)
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');
  }

  findVariant() {
    if (!this.selectedOptions.length) {
      return this.variants.find((variant) => variant.available) || this.variants[0];
    }
    return this.variants.find((variant) => {
      if (!variant.options || variant.options.length !== this.selectedOptions.length) return false;
      return variant.options.every((option, index) => option === this.selectedOptions[index]);
    });
  }

  syncVariant() {
    const variant = this.findVariant();
    if (!variant) {
      this.addButton.disabled = true;
      return;
    }

    this.idInput.value = variant.id;
    if (this.priceEl) this.priceEl.textContent = variant.price_formatted;
    if (this.imageEl && variant.image) this.imageEl.src = variant.image;
    this.syncQuantityOptions(variant);
    this.addButton.disabled = !variant.available;
    this.addButton.textContent = variant.available ? 'Add' : 'Sold out';
  }

  async handleAdd() {
    const id = Number(this.idInput.value);
    const quantity = Number(this.qtyInput?.value || this.quantity || 1);
    if (!id || this.addButton.disabled) return;

    const originalText = this.addButton.textContent;
    this.addButton.disabled = true;
    this.addButton.textContent = 'Adding...';

    try {
      const response = await fetch(window.Shopify?.routes?.root ? `${window.Shopify.routes.root}cart/add.js` : '/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          items: [{ id, quantity }],
        }),
      });

      if (!response.ok) throw new Error('Unable to add item');

      await response.json();
      if (window.theme?.cart?.render) {
        window.theme.cart.render();
      } else {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      }
      this.addButton.textContent = 'Added';
      setTimeout(() => {
        this.addButton.textContent = originalText;
        this.addButton.disabled = false;
      }, 1200);
    } catch (error) {
      console.error(error);
      this.addButton.textContent = originalText;
      this.addButton.disabled = false;
      alert('Sorry, we could not add that item. Please try again.');
    }
  }
}

if (!customElements.get('product-addon')) {
  customElements.define('product-addon', ProductAddon);
}
